module.exports = __webpack_public_path__ + "static/media/undoImg.3dbbae76.svg";